<div class="flex justify-content-center">
    <div class="flex justify-content-center">
        <p-overlayPanel
            [styleClass]="isPortraitDevice ? 'mobile' : 'desktop'"
            id="financialSimulator"
            #financialSimulator
            (onShow)="onShowFinancialSimulator($event)"
            (onHide)="onHideFinancialSimulator($event)"
        >
            <div class="main-financial-cart">
                <div *ngIf="!isPortraitDevice" class="financial-cart">
                    <app-financial-simulator
                        [brand]="brand"
                        [model]="model"
                        [data]="financialData"
                        (isOpenedFinancialCart)="financialSimulator.toggle($event)"
                    >
                    </app-financial-simulator>
                </div>

                <div *ngIf="isPortraitDevice" class="financial-cart-mobile">
                    <app-financial-simulator-mobile
                        class="financial-cart-mobile"
                        [brand]="brand"
                        [model]="model"
                        [data]="financialData"
                        [isPortraitDevice]="isPortraitDevice"
                        (isOpenedFinancialCart)="financialSimulator.toggle($event)"
                    >
                    </app-financial-simulator-mobile>
                </div>
            </div>
        </p-overlayPanel>
    </div>

    <div *ngIf="!isOpenFinancialSimulator || isPortraitDevice" class="">
        <button
            id="openButton"
            class="custom-cart-button"
            type="button"
            (click)="financialSimulator.toggle($event)"
            [ngClass]="{ 'is-portrait': isPortraitDevice }"
        >
            <div class="custom-cart-box">
                <!-- Comentamos la imagen por el momento -->
                <!-- <img
                    class="thumbnail"
                    *ngIf="!isPortraitDevice"
                    [src]="'./assets/img/themes/' + brand + '/models/' + model + '_cart_icon.png'"
                    alt=""
                    width="40"
                    height="40"
                /> -->

                <div *ngIf="financialData" class="cart-info">
                    <span *ngIf="!isPortraitDevice" class="car-model"> {{ brand }} {{ model }} </span>

                    <span class="car-price"> {{ financialData.installmentMonthlyGrossAmount }} €/mes </span>
                </div>

                <i *ngIf="!isOpenFinancialSimulator" class="ri-arrow-down-s-line custom-cart-icon"></i>
                <i *ngIf="isOpenFinancialSimulator" class="ri-arrow-up-s-line custom-cart-icon"></i>
            </div>
        </button>
    </div>

    <!--
    <div *ngIf="isOpenFinancialSimulator && !isPortraitDevice" class="flex close-cart-box">
        <button id="closeButton" class="button-close button-rounded" type="button" (click)="financialSimulator.toggle($event)">
            <i class="ri-close-fill"></i>
        </button>
    </div>
     -->
</div>
